(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-product-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('animated-product-hero')) {
    customElements.define(
      'animated-product-hero',
      class AnimatedProductHero extends HTMLElement {
        connectedCallback() {
          if (this.dataset.motionBound === 'true') return;
          this.dataset.motionBound = 'true';

          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (reducedMotion || !('IntersectionObserver' in window)) {
            this.classList.add('is-visible');
            return;
          }

          this.classList.add('motion-initialized');

          const repeatAnimation = this.dataset.repeatAnimation === 'true';
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.classList.add('is-visible');

                  if (!repeatAnimation) {
                    this.observer.unobserve(this);
                  }
                } else if (repeatAnimation) {
                  this.classList.remove('is-visible');
                }
              });
            },
            {
              threshold: 0.2,
              rootMargin: '0px 0px -8% 0px'
            }
          );

          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) {
            this.observer.disconnect();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
